/*
 * The Course Builder's launch switch. Shown by default on the web and in
 * Desktop: on the web the community catalogue, viewer and library work for
 * everyone and paid members are sent to Desktop to run a build. To hide the
 * AI tabs on the web, build with REACT_APP_COURSE_BUILDER_ON_WEB=false
 * (Desktop builds that have the bridge always show them).
 */
export const COURSE_BUILDER_ON_WEB = process.env.REACT_APP_COURSE_BUILDER_ON_WEB !== 'false';

export function courseBuilderVisible(
  win = typeof window !== 'undefined' ? window : undefined,
  onWeb = COURSE_BUILDER_ON_WEB,
) {
  return onWeb || !!win?.courseBuilder;
}
